import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import axios from 'axios';

// ---------------------------------------------------------------------------
// CSRF token — fetched once at startup and attached to every mutating request.
// ISO 27001 A.8.20 / SOC 2 CC6.6
// ---------------------------------------------------------------------------
let csrfToken = '';
async function fetchCsrfToken() {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/csrf-token`,
      { credentials: 'include' }
    );
    const data = await res.json();
    csrfToken = data.csrfToken || '';
  } catch {
    // Non-fatal — requests will proceed without CSRF token and server will reject
    // mutating calls, which is the safe-fail behaviour.
  }
}

// ---------------------------------------------------------------------------
// Axios — scope credentials to the API origin only (not every domain).
// Attach X-CSRF-Token and X-Firm-Slug on every request.
// ISO 27001 A.8.20 / SOC 2 CC6.1
// ---------------------------------------------------------------------------
const API_ORIGIN = new URL(process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000').origin;

axios.interceptors.request.use((config) => {
  // Only send cookies to our own API — not to any third-party domain
  if (config.url && config.url.startsWith(API_ORIGIN)) {
    config.withCredentials = true;
  }
  if (csrfToken) config.headers['x-csrf-token'] = csrfToken;
  // x-firm-slug removed — trader app is global, firm context comes from JWT authorizedFirms
  return config;
});

// ---------------------------------------------------------------------------
// Patch global fetch — attach X-CSRF-Token and X-Firm-Slug on every call.
// ---------------------------------------------------------------------------
const _originalFetch = window.fetch.bind(window);
window.fetch = async (input, init = {}) => {
  const headers = { ...(init.headers || {}) };
  if (csrfToken) headers['x-csrf-token'] = csrfToken;
  // x-firm-slug removed — trader app is global, firm context comes from JWT authorizedFirms
  return _originalFetch(input, { ...init, headers });
};

// Fetch CSRF token before rendering so the first request already has it
fetchCsrfToken().then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
});

reportWebVitals();
